const projectData = [
    {
        name:"MoreLife",
        desc:"A minimalist editorial site for a contemporary clothing brand, built around fabric, craft, and quiet design.",
        problem:"Clothing brand sites often reduce a collection to a product grid, with no sense of the philosophy or craft behind it.",
        solution:"Built an editorial-style React site structured around the brand's story — design philosophy, fabric selection, and construction process — instead of a plain catalog.",
        tech:"React, Tailwind, Prisma, PostgreSQL",
        img:"./project_img/moreLife.png",
        class:"right",
        link:"https://morelifee.netlify.app/"
    },
    {
        name:"Maestro",
        desc:"A multi-agent system in LangGraph coordinating four agents — orchestrator, researcher, writer, critic — with retrieval, evaluation, and deployment built in.",
        problem:"Long, multi-step LLM workflows tend to drift, lose context, or hand back ungrounded answers with no way to check quality.",
        solution:"Built a stateful multi-agent graph in LangGraph — orchestrator, researcher, writer, and critic — with a custom MCP server, a connected public MCP server for tool access, and a ChromaDB retrieval layer for citation-backed answers.",
        impact:"An LLM-as-judge evaluation harness scores task success and groundedness across test cases. Containerized (Docker, ARM64) and deployed on AWS Bedrock AgentCore Runtime.",
        tech:"LangGraph, MCP, ChromaDB, FastAPI, AWS Bedrock AgentCore, Docker",
        img:"./project_img/maestro.svg",
        class:"left",
        link:"https://github.com/justShashank57/maestro"
    },
    {
        name:"MedMeet",
        desc:"A doctor appointment platform connecting patients with healthcare professionals for fast, easy bookings.",
        problem:"Booking a doctor's appointment online is usually clunky, or still means calling in.",
        solution:"Built a full-stack booking platform end to end — patient and provider flows, auth, and a MongoDB-backed data layer.",
        tech:"MongoDB, React, Express, Node",
        img:"./project_img/medMeet.webp",
        class:"right",
        link:"https://medmeet-tyson.netlify.app/"
    },
    {
        name:"Quizzical",
        desc:"An online quiz app pulling live questions from a public API.",
        problem:"Hard-coded quiz content gets stale fast.",
        solution:"Built a React quiz app that pulls live questions from a public trivia API and manages scoring and answer state client-side.",
        tech:"React",
        img:"./project_img/quiz.webp",
        class:"left",
        link:"https://quizzical-byshanky.netlify.app/"
    },
    {
        name:"ArtGenius.ai",
        desc:"An AI art generator using the DALL-E API to turn text prompts into images.",
        problem:"Turning a text idea into an image usually means opening a design tool.",
        solution:"Built a React/Node app that wraps the DALL-E API, so a text prompt returns generated art in a few clicks.",
        tech:"MongoDB, React, Express, Node",
        img:"./project_img/artGenius.webp",
        class:"left",
        link:"https://art-genius-shanky.netlify.app/"
    },
    {
        name:"Speed Typing",
        desc:"A typing speed test built with React.",
        tech:"React",
        img:"./project_img/typing2.webp",
        class:"right",
        link:"https://speedtyping-shashank.netlify.app/"
    },
    {
        name:"Tenzies Game",
        desc:"A number-matching dice game built with React hooks.",
        tech:"React",
        img:"./project_img/tenzies.webp",
        class:"left",
        link:"https://tenzies-byshanky.netlify.app/"
    },
    {
        name:"Meme generator",
        desc:"A meme generator with editable templates.",
        tech:"React",
        img:"./project_img/meme2.webp",
        class:"right",
        link:"https://meme-generator-shashank.netlify.app/"
    },
    {
        name:"Spotify",
        desc:"A Spotify clone with MongoDB-backed songs, profiles, and likes.",
        tech:"HTML, CSS, JS",
        img:"./project_img/spotify.webp",
        class:"left",
        link:""

    },
    {
        name:"Tic-Tac-Toe",
        desc:"Classic tic-tac-toe built in vanilla JavaScript.",
        tech:"HTML, CSS, JS",
        img:"./project_img/ticTac.webp",
        class:"right",
        link:"https://tic-tac-toe-shashank.netlify.app/"
    }
];

export default projectData;
